import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NeedHelpComponent } from 'src/app/components/participants/need-help/need-help.component';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-dashboard-participant',
    templateUrl: './dashboard-participant.component.html',
    styleUrls: ['./dashboard-participant.component.scss'],
    standalone: false
})

export class DashboardParticipantComponent {

  loggedUserDisplayName: string = '';
  bannerSubTitle: string = '';
  recommendedBy: string = '';
  participantClassByRole: string = 'bb-coached-color';
  llttfPage: boolean = false;
  courseButtonName: string = '';
  translation: any;
  checkin_information: string = '';
  plan_information: string = '';

  constructor(private dialog: MatDialog,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService) {
  }

  async ngOnInit(): Promise<void> {

    await this.translationservice.getTranslation().subscribe({
      next: (translations) => {
        this.translation = translations;
        this.themeService.setThemeLabels(this.translation);
        this.themeService.setParticipantTheme();

        this.llttfPage = this.themeService.llttfPage;
        this.participantClassByRole = this.themeService.participantClassByRole;
        this.recommendedBy = this.themeService.recommendedBy;
        this.loggedUserDisplayName = this.themeService.loggedUserDisplayName;
        this.bannerSubTitle = this.themeService.bannerSubTitle;
        this.courseButtonName = this.themeService.courseButtonText;
        this.plan_information = this.translation.planInformationPopupText;
        this.checkin_information = this.translation.moodCheckinInfoText;
      }
    });
  }

  openNeedHelpModal() {
    const dialogRef = this.dialog.open(NeedHelpComponent, {
      data: {
        showDesc: false
      },
      width: 'min(680px, 94vw)',
      maxWidth: '96vw',
      maxHeight: '92vh',
      panelClass: 'need-help-panel',
      backdropClass: 'needhelp-backdrop',
      hasBackdrop: true
    });

    dialogRef.afterClosed().subscribe(result => { });
  }
}

